import styled from "styled-components";

export const MyPreferencesModalStyled = styled.div`
  padding: 32px 250px;
  height: calc(100vh - 56px);
  overflow: auto;
`;
